<template>
  <qx-card-form title="司机信息" v-show="showComponent" :defaultContentShow="false">
    <DriverInfoComponent
      ref="driverInfoComponent"
      :masterDriver="driverUser"
      :copilotDriver="copilotDriver"
      :vehicleClass="vehicleClass"
      @chooseDriver="(driverInfo) => driverUser = driverInfo"
      @chooseCopilotDriver="(driverInfo) => copilotDriver = driverInfo"
    />
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
import DriverInfoComponent from './driverInfoComponent';
export default {
  components: {
    DriverInfoComponent,
  },
  props: {
    // 车辆种类
    vehicleClass: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      showComponent: false,
      // 主驾
      driverUser: {
        driverUserId: '',
        driverUserPhone: '',
        driverUserName: '',
      },
      // 副驾
      copilotDriver: {
        copilotDriverId: '',
        copilotDriverPhone: '',
        copilotDriverName: '',
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    async handleSubData (cache) {
      let formData = null;
      const _this = await this.$refs.driverInfoComponent;
      if (cache) {
        formData = await _this.$refs.baseForm.getVal();
      } else {
        formData = await _this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        if (this.$route.query.type === 'outward') {
          // 外调车模式下，不需要提交司机信息，如果提交则会覆盖 base.vue 组件的司机信息
          formData = {};
        }
      }
      return formData;
    },
    async cacheData () {
      const _this = await this.$refs.driverInfoComponent;
      const formData = await _this.handleSubData(true);
      return formData;
    },
    async sub () {
      const _this = await this.$refs.driverInfoComponent;
      const formData = await _this.handleSubData();
      // console.log('司机信息提交参数', formData);
      return formData;
    },
    init (data = {}) {
      this.driverUser = {
        driverUserId: data.driverUserId,
        driverUserPhone: data.driverMobilePhone,
        driverUserName: data.driverName,
        driverCarUserType: data.driverCarUserType || '',
      };
      this.copilotDriver = {
        copilotDriverId: data.copilotDriverId,
        copilotDriverPhone: data.copilotDriverMobilePhone,
        copilotDriverName: data.copilotDriverUserName,
        copilotDriverUserType: data.copilotDriverUserType || '-1',
      };
      this.showComponent = this.$route.query.type === 'my';
    },
    // 修改车辆种类为【临时外调车时】
    changeToOutward () {
      // 切换成临时外调车
      this.setBaseForm('outward');
    },
    resetToNormal () {
      // 恢复成正常模式
      this.setBaseForm('my');
    },
    setBaseForm (mode) {
      if (mode === 'my') {
        this.showComponent = true;
      } else {
        this.showComponent = false;
      }
    },
    resetBaseForm () {
      this.setBaseForm(this.$route.query.type);
    },
    formChange (vehicleInfo) {
      this.resetBaseForm();
    },
    receivedData (vehicleInfo) {
      this.formChange(vehicleInfo);
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
